<template>
  <custom-callout :has-toggle="false" class="mb-3" border-color="gray">
    <div class="d-flex align-items-center justify-content-between">
      <div v-if="item.certified">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Fecha de Certificación:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.certificationDate | date }}
        </div>
      </div>
      <div v-if="item.certified">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Fecha de Vigencia:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.expirationDate | date }}
        </div>
      </div>
      <div v-if="!item.certified">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Comentario:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.comment | empty }}
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center">
          <badge :value="item.certified" text="Certificada" />
          <div :class="{ hidden: !hasFile }">
            <action-button
              i="fas fa-file-download"
              variant="success ml-3"
              @click="download"
            />
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import Badge from '@/components/common/Badge';

import generalService from '@/services/pei/general';

export default {
  name: 'MedicaidCertificationRow',
  components: {
    CustomCallout,
    ActionButton,
    Badge,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    hasFile() {
      return Boolean(this.item.document ?? this.item.file);
    },
  },
  methods: {
    download() {
      const { file, document } = this.item;
      const item = file ?? document;
      const isFile = item instanceof File;
      if (isFile) generalService.documentDownloadLocalFile(item);
      else generalService.getDocument(item.id);
    },
  },
};
</script>
<style scoped></style>
